import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';

import { TabManagementService } from './tab-management.service';

export function provideTabManagement(): EnvironmentProviders {
  return provideAppInitializer(() => {
    inject(TabManagementService).init();
  });
}
